export { default as Testimonials } from './Testimonials';
